
export default {
  name: 'AppCheckbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean],
      default: '1'
    },
    label: {
      type: String,
      default: null
    },
    inputPosition: { type: String, default: 'right' },
    accentColor: { type: String, default: null },
    size: { type: Number, default: 15 }
  },
  data() {
    return {
      currentChecked: this.checked
    };
  },
  watch: {
    checked() {
      this.currentChecked = this.checked;
    }
  },
  methods: {
    change(e) {
      this.currentChecked = e.target.checked;
      this.$emit('change', this.currentChecked);
    }
  }
};
